import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "@/templates/Dashboard.vue";
import DashboardRouter from "@/router/DashboardRouter";

import Account from "@/templates/Account.vue";
import AuthRouter from "@/router/AuthRouter";

import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/auth",
    name: "Auth",
    component: Account,
    children: AuthRouter,
    meta: {
      title: "MijnSPITS"
    }
  },
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    children: DashboardRouter,
    meta: {
      title: "MijnSPITS"
    },
    beforeEnter: (to, from, next) => {
      const isAuthenticated = store.getters["auth/isLoggedIn"];
      if (!isAuthenticated) {
        next({
          path: "/auth"
        });
      } else {
        next();
      }
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
